import cn from "classnames";
import { useTranslation } from "shared/localization/localization";
import styles from "./MobileToggle.module.scss";

export type MobileToggleVariant = "sea" | "air" | "global";

type MobileToggleProps = {
  isPanelVisible: boolean;
  onSwitch: (isPanelVisible: boolean) => void;
  variant?: MobileToggleVariant;
};

const variantClassName: Record<MobileToggleVariant, string> = {
  sea: styles.variantSea,
  air: styles.variantAir,
  global: styles.variantGlobal,
};

const MobileToggle: RFC<MobileToggleProps> = ({ isPanelVisible, onSwitch, variant = "sea" }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={cn(styles.containerFiller, variantClassName[variant])}>
        <div className={styles.buttonBox}>
          <button type="button" onClick={() => onSwitch(true)} className={styles.switchButton}>
            {t("Details")}
          </button>
          <button type="button" onClick={() => onSwitch(false)} className={styles.switchButton}>
            {t("Map")}
          </button>
        </div>
        <div className={cn(styles.filler, { [styles.fillerRight]: !isPanelVisible })}>
          {isPanelVisible ? t("Details") : t("Map")}
        </div>
      </div>
    </div>
  );
};

export { MobileToggle };
